import {
  FormControlLabel,
  Radio as MUIRadio,
} from '@mui/material';
import React from 'react';

type RadioProps = {
  name?: string;
  label: string | React.ReactNode;
  labelPlacement?: 'bottom' | 'end' | 'start' | 'top';
  size?: 'small' | 'medium';
  value: string | number | boolean;
  handleBlur?: any;
  handleOnChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  formControlClassName?: string;
  disabled?: boolean
};

const noop = () => {};

const Radio = ({
  name,
  label,
  labelPlacement = 'end',
  size = 'medium',
  value,
  handleBlur,
  handleOnChange = noop,
  formControlClassName,
  disabled = false
}: RadioProps) => (
  <FormControlLabel
    name={name}
    label={label}
    labelPlacement={labelPlacement}
    value={value}
    className={formControlClassName}
    disabled={disabled}
    control={(
      <MUIRadio
        size={size}
        onBlur={handleBlur}
        onChange={handleOnChange}
      />
    )}
  />
);

export default Radio;
